module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/user-list/user-list.component.scss
// module id = 1501
// module chunks = 0